import React from "react";
import { Chip, ChipProps } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"; // optional, or pass a custom one
import { SxProps } from "@mui/system";

type StatusColor = "Closed" | "In Review" | "Rejected" | "Filter" | string;
type Variant = "small" | "medium";

interface StatusChipProps {
  label: any;
  color?: StatusColor;
  variant?: Variant;
  onDelete?: () => void; // optional delete handler
  icon?: any; // for custom icons
  sx?: SxProps; // to allow additional styles
}

const statusStyles: Record<string, React.CSSProperties> = {
  Closed: {
    color: "#2E7D32",
    backgroundColor: "#EBF4EC",
    border: "1px solid #C1DCC3 !important",
  },
  "In Review": {
    color: "#585A64",
    backgroundColor: "#FFF9EA",
    border: "1px solid #FEEBBE !important",
  },
  Rejected: {
    color: "#C62828",
    backgroundColor: "#FBEAEA",
    border: "1px solid #F1BFBF !important",
  },
  Filter: {
    color: "#373A45",
    backgroundColor: "#EDEEF1",
  },
};

const StatusChip: React.FC<StatusChipProps> = ({
  label,
  color = "default",
  variant = "medium",
  onDelete,
  icon,
  sx,
}) => {
  const style =
    statusStyles[color] || {
      color: "#424242",
      backgroundColor: "#F5F5F5",
      border: "1px solid #E0E0E0 !important",
    };

  const chipSize: ChipProps["size"] = variant === "small" ? "small" : "medium";

  return (
    <Chip
      label={label}
      size={chipSize}
      icon={icon}
      onDelete={onDelete}
      deleteIcon={onDelete ? <CloseIcon sx={{ fontSize: 18, color: "#5E72E4" }} /> : undefined}
      sx={{
        ...style,
        fontWeight: 500,
        borderRadius: "16px",
        px: 1,
        textTransform: "capitalize",
        ...sx,
      }}
    />
  );
};

export default StatusChip;
